// family package
export const BUNDLE_FAMILY_SWITCHING_PATH = 'family'
export const BUNDLE_FAMILY_NAVIGATION_STATE = 'familyPackage'
